import React from 'react';
import CarousalMsg from '../components/Carousal';
import Contact from '../components/Contact';
import DocumentCustom from '../components/DocumentCustom';
import Image from '../components/Image';
import MultiChoice from '../components/MultiChoice';
import Text from '../components/Text';
import Audio from '../components/audio';
import Card from '../components/card';
import Location from '../components/location';
import Video from '../components/video';
import { addUserMessage } from '../components/index.js';
import WebSocketManager from '../manager/WebSocketManager.js';
import { getUUID } from './uuid';
import TimeStamp from '../components/TimeStamp.jsx';
import Rating from '../components/Rating.jsx';
import { useSelector } from 'react-redux';
const webSocketManager = new WebSocketManager();

export const getCorrectComponent = (message, config = {}) => {
  const { widgetConfig } = useSelector((state) => ({
    widgetConfig: state.messages.widgetConfig,
  }));
  const handleImage = (src, msg, fileType) => {
    sendMessageToParent({ type: 'IMAGE_SCREEN', url: src, caption: msg || '', fileType: fileType });
  };
  const sendMessageToParent = (message) => {
    window.parent.postMessage(message, '*');
  };

  const type = message?.content?.type || message?.type || message?.data?.fileType || '';
  switch (type) {
    case 'image':
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            <Image
              src={message?.content?.link || message?.data?.link || null}
              alt="Image not loaded."
              message={
                message?.content?.caption || message?.endText || message?.content?.text || ''
              }
            />
          </div>
          <TimeStamp message={message} />
        </div>
      );
    case 'video':
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            <Video
              src={message?.content?.link || message?.data?.link || ''}
              type={'video/mp4'}
              message={
                message?.content?.caption || message?.content?.text || message?.endText || ''
              }
            />
          </div>
          <TimeStamp message={message} />
        </div>
      );
    case 'document':
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            <DocumentCustom
              docType={message?.content?.mimeType || message?.data?.mimeType || ''}
              docLink={message?.content?.link || message?.data?.link || ''}
              fileName={message?.content?.fileName || message?.data?.fileName || ''}
              fileSize={message?.content?.fileSize || 0}
              message={
                message?.content?.caption || message?.endText || message?.content?.text || ''
              }
            />
          </div>
          <TimeStamp message={message} />
        </div>
      );
    case 'contacts':
      const contactData = message?.content?.contact || '';
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            {contactData.map((contact, index) => (
              <Contact key={index} contact={contact} />
            ))}
          </div>
          <TimeStamp message={message} />
        </div>
      );
    case 'card':
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            <Card cardData={message?.content?.card || ''} />
          </div>
          <TimeStamp message={message} />
        </div>
      );
    case 'carousel':
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            <CarousalMsg message={message?.content?.cards || ''} />
          </div>
          <TimeStamp message={message} />
        </div>
      );
    case 'location':
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            <Location
              longitude={message?.content?.longitude}
              latitude={message?.content?.latitude}
              address={message?.content?.address}
              addressName={message?.content?.addressName}
            />
          </div>
          <TimeStamp message={message} />
        </div>
      );
    case 'multiChoice':
      if (message?.content?.options) {
        message.content.options = message.content.options.map((option, index) => {
          return {
            ...option,
            onClick: () => {
              disableAllOptions(message.content.options);
              addUserMessage(option.title);
              webSocketManager.send({
                id: getUUID(),
                payloadType: 'message',
                type: 'text',
                from: 'customer',
                timeStamp: new Date(),
                content: {
                  text: option.title,
                },
              });
            },
          };
        });
      }
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            <MultiChoice
              text={message?.content?.text || ''}
              options={message?.content?.options || null}
            />
          </div>
          <div className="rcw-multichoice-footer">
            <TimeStamp message={message} />
            <div className="rcw-multichoice-option">
              {message?.content?.options?.map((option) => {
                if(!option?.title ||option?.title === ' ' || option?.title === ''){
                  return null;
                }
                return (
                  <button
                    style={{
                      margin: '5px',
                      background:
                        widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor === '#ffffff'
                          ? widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor
                          : '',
                      color:
                        widgetConfig?.widgetConfig.lookAndFeel?.backgroundColor === '#ffffff'
                          ? '#000000'
                          : '',
                    }}
                    key={option?.title + option?.id}
                    disabled={option?.disabled}
                    onClick={option?.onClick ? option.onClick : () => {}}>
                    {option?.title || ''}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      );
    case 'audio':
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            <Audio
              src={message?.content?.link || message?.data?.link || ''}
              message={
                message?.content?.caption || message?.endText || message?.content?.text || ''
              }
              messageObj={message}
            />
          </div>
          <TimeStamp message={message} />
        </div>
      );
    case 'text':
      return (
        <div>
          <div className="rcw-receiver-container">
            {message?.from !== 'customer' &&
            message?.from === 'flow' &&
            message?.sender !== 'client' &&
            !message?.data?.output ? (
              <img className="rcw-avatar " src="./images/receiver-msg.svg" />
            ) : message?.from === 'agent' ? (
              <img className="rcw-avatar " src="./images/real-agent.svg" />
            ) : (
              ''
            )}
            <Text message={message?.content || message} />
          </div>
          <TimeStamp message={message} />
        </div>
      );
    case 'close':
      return (
        <>
          {config?.widgetConfig?.lookAndFeel && config?.widgetConfig?.lookAndFeel?.rating && (
            <div>
              <div className="rcw-receiver-container">
                {/* {message?.from !== 'customer' &&
                message?.from === 'flow' &&
                message?.sender !== 'client' &&
                !message?.data?.output ? (
                  <img className="rcw-avatar " src="./images/receiver-msg.svg" />
                ) : message?.from === 'agent' ? (
                  <img className="rcw-avatar " src="./images/real-agent.svg" />
                ) : (
                  ''
                )} */}
                <Rating message={message?.content || message} />
              </div>
              {/* <TimeStamp message={message} /> */}
            </div>
          )}
        </>
      );
    default:
      return <></>;
    // return <div style={{ color: 'black' }}>{`Fixed Me :` + type}</div>;
  }
  return '';
};
function disableAllOptions(options) {
  for (const option of options) {
    option.disabled = true;
  }
}
